import {
	AnchorPointIcon,
	ArrowRight02Icon,
	ChipIcon,
	ComputerIcon,
	CpuIcon,
	EnergyIcon,
	FlashIcon,
	HardDriveIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

const ICON_POOL = [CpuIcon, ChipIcon, EnergyIcon, FlashIcon, AnchorPointIcon, HardDriveIcon, ComputerIcon];

const pickIcon = (key: string) => {
	const k = (key || '').toLowerCase();
	if (k.includes('plc') || k.includes('hmi') || k.includes('cpu')) return CpuIcon;
	if (k.includes('chip') || k.includes('vi mạch') || k.includes('cảm biến') || k.includes('sensor')) return ChipIcon;
	if (k.includes('biến tần') || k.includes('servo') || k.includes('điện') || k.includes('energy')) return EnergyIcon;
	if (k.includes('đo') || k.includes('gauge') || k.includes('meter')) return FlashIcon;
	if (k.includes('hàng hải') || k.includes('tàu') || k.includes('marine') || k.includes('ship')) return AnchorPointIcon;
	if (k.includes('lưu trữ') || k.includes('drive') || k.includes('disk')) return HardDriveIcon;
	if (k.includes('máy tính') || k.includes('computer')) return ComputerIcon;
	return null;
};

interface Category {
	id: string;
	name: string;
	[key: string]: any;
}

interface Props {
	categories: Category[];
	productCounts?: Record<string, number>;
}

const FeaturedCategories = ({ categories, productCounts = {} }: Props) => {
	const items = useMemo(() => {
		return categories.slice(0, 8).map((c, i) => ({
			...c,
			icon: pickIcon(c.name) ?? ICON_POOL[i % ICON_POOL.length],
			count: productCounts[c.id] ?? 0,
		}));
	}, [categories, productCounts]);

	if (items.length === 0) return null;

	return (
		<section className='container py-10 pt-10 pb-3'>
			<div className='section-heading'>
				<h2>Danh mục nổi bật</h2>
				<Link to='/tim-kiem' className='view-all'>
					Xem tất cả <HugeiconsIcon icon={ArrowRight02Icon} size={14} />
				</Link>
			</div>
			<div className='grid grid-cols-2 md:grid-cols-4 gap-3'>
				{items.map((c) => (
					<Link key={c.id} to={`/tim-kiem?cat=${c.id}`} className='catcard'>
						<div className='iconbox'>
							<HugeiconsIcon icon={c.icon} size={24} />
						</div>
						<div className='meta'>
							<div className='name'>{c.name}</div>
							<div className='count'>{c.count} sản phẩm</div>
						</div>
					</Link>
				))}
			</div>
		</section>
	);
};

export default FeaturedCategories;
